
import React,{useContext, useEffect,useRef,useState} from 'react'
import Button from '../components/Button'
import { PiEraserLight, PiFloppyDiskDuotone, PiFloppyDiskLight, PiImageDuotone, PiImageThin, PiPencilSimple, PiTrashLight } from 'react-icons/pi';
import EditableComplonent from './EditableComponent';
import FormDialog from './FormDialog';
import client from '../client';
import { GlobalContext } from '../contexts/GlobalContext';

const MainSlide = () => {
    const {version,slideData} = useContext(GlobalContext);
    const [user,setUser] = useState(null);
    const [current,setCurrent] = useState(null);
    const [next,setNext] = useState(null);
    const [hasEditAuth,setEditAuth] = useState(false);
    const currentRef = useRef(null);
    const nextRef = useRef(null);
    const editSlidesDataRef = useRef(null);

    const {request,getCurrent,sendFormData,download,errorMessage} = client;

    /* const slideData = [
        {
            image:'/images/img_59_sm.jpg',
            text1:'welcome to',
            text2:"The Clinical Officers' Association of Zambia"
        },
        {
            image:'/images/img_60_sm.jpg', 
            text1:'we are your voice', 
            text2:"Advocating for all Clinical Officers"
        }
    ] */

    /* useEffect(() => {
        setSlides(slideData.map((slide) => 
            ({
                Content: () => 
                <Slide 
                    image={slide.file}
                    name={slide.name} 
                    description={slide.description}
                    buttonText='Join us'
                />
            })
        ))
    },[slideData]) */

    useEffect(() => {
        /* getCurrent()
        .then((response) => {
            if(response && response.user) {
                setUser(response.user);
                let create = response.authorities.find((auth) => {return auth.authority === 'SLIDE:CREATE'});
                let read = response.authorities.find((auth) => {return auth.authority === 'SLIDE:READ'});
                let update = response.authorities.find((auth) => {return auth.authority === 'SLIDE:UPDATE'});
                let remove = response.authorities.find((auth) => {return auth.authority === 'SLIDE:DELETE'});
                setEditAuth(create || read || update || remove);
            }
        })
        .catch(() => {}) */

        if (!slideData.length) {
            setCurrent(null);
            setNext(null);
            return;
        }

        if(slideData.length == 1) {
            setCurrent({index:0,slide:slideData[0]});
            setNext(null);
            return;
        }

        let i = 0;
        let index = 0;
        const interval = setInterval(() => {
            if(i == 0) {
                setCurrent({index:index,slide:slideData[index]});
            }
            if(i == 1) {
                if(currentRef.current) {
                    currentRef.current.style.opacity = '1';
                    currentRef.current.style.transition ='none';
                }
                if(nextRef.current) {
                    nextRef.current.style.left = '16px';
                    nextRef.current.style.top = '16px';
                    nextRef.current.style.right = '16px';
                    nextRef.current.style.bottom = '16px';
                    nextRef.current.style.transition = 'none';
                }
            }
            if(i == 2) {
                if((index + 1) < slideData.length) { 
                    setNext({index:index + 1,slide:slideData[index + 1]});
                } else {
                    setNext({index:0,slide:slideData[0]});
                }
            }
            if(i == 20) {
                if(currentRef.current) {
                    currentRef.current.style.opacity = '0';
                    currentRef.current.style.transition ='all .8s ease-in-out';
                }
                if(nextRef.current) {
                    nextRef.current.style.left = '0';
                    nextRef.current.style.top = '0';
                    nextRef.current.style.right = '0';
                    nextRef.current.style.bottom = '0';
                    nextRef.current.style.transition = 'all 1s  ease-in-out';
                }
                if(index < slideData.length - 1) {
                    index++;
                } else {
                    index = 0;
                }
            }
            if(i < 20) {
                i++;
            } else {
                i = 0;
            }
        },500);
        
        return () => {
            clearInterval(interval);
        }
    },[slideData])
    
    useEffect(() => {
        getCurrent()
        .then((response) => {
            if(response && response.user) {
                setUser(response.user);
                let create = response.authorities.find((auth) => {return auth.authority === 'SLIDE:CREATE'});
                let update = response.authorities.find((auth) => {return auth.authority === 'SLIDE:UPDATE'});
                let remove = response.authorities.find((auth) => {return auth.authority === 'SLIDE:DELETE'});
                setEditAuth(create || update || remove);
            }
        })
        .catch(() => {})
    },[version])

    const appendToFormData = (formData, key, value) => {

        // Handle file safely first
        if (key.endsWith(".file") || key === "file") {
            if (value instanceof File) {
                formData.append(key, value);
            }
            return;
        }

        // Skip null/undefined (IMPORTANT: do NOT convert to "")
        if (value === null || value === undefined) {
            return;
        }

        if (Array.isArray(value)) {
            value.forEach((item, index) => {
                appendToFormData(formData, `${key}[${index}]`, item);
            });
            return;
        }

        if (typeof value === "object") {
            Object.entries(value).forEach(([k, v]) => {
                if (k === "tempId") return;

                appendToFormData(formData, `${key}.${k}`, v);
            });
            return;
        }

        formData.append(key, value);
    };

    const onSubmit = async (e) => {
        if(!editSlidesDataRef || !editSlidesDataRef.current) {
            return {message:'No data'};
        }

        const formData = new FormData();

        editSlidesDataRef.current.forEach((editSlide, index) => {
            Object.entries(editSlide).forEach(([key, value]) => {
                if (key === "tempId") {
                    return;
                }

                appendToFormData(
                    formData,
                    `auditables[${index}].${key}`,
                    value
                );
            });
        });

        let result = false;
        await sendFormData("POST","slides/all", formData)
        .then((response) => {
            result = {message:'Successful', success:true};
        })
        .catch((error) => {
            console.log(error);
            result = {message:errorMessage(error)};
        });

        return result;
    }

    return (
        <EditableComplonent 
            title="Edit Slides"
            Dialog={EditSlides}
            params={{
                currentSlides:slideData, 
                editSlidesDataRef:editSlidesDataRef
            }}
            submit={onSubmit}
            hasAuthority={hasEditAuth}>
            <div className='relative flex flex-col w-full h-[70vh] shrink-0 overflow-hidden bg-white'>
                {next && 
                    <div ref={nextRef} style={{left:'16px',top:'16px',right:'16px',bottom:'16px'}} 
                        className='absolute overflow-hidden'>
                        {next && next.slide && 
                        <Slide 
                            image={next.slide.file}
                            name={next.slide.name} 
                            description={next.slide.description}
                            user={user}
                        />}
                    </div>
                }
                {current && current.slide &&
                    <div ref={currentRef} style={{left:'0',top:'0',right:'0',bottom:'0'}} 
                        className='absolute overflow-hidden'>
                        {current && current.slide && 
                         <Slide 
                            image={current.slide.file}
                            name={current.slide.name} 
                            description={current.slide.description}
                            user={user}
                        />}
                    </div>
                }
                <div className='absolute flex flex-row space-x-2 items-center justify-center bottom-0 w-full h-[96px]'>
                    {slideData && slideData.length > 1 && (
                        (() => {
                            let bullets = [];
                            for(let i = 0;i < slideData.length;i++) {
                                bullets.push(<Bullet key={i} index={i} current={current}/>);
                            }
                            return bullets;
                        })()
                    )}
                </div>
                
            </div>
        </EditableComplonent>
    )
}

export default MainSlide

const Slide = ({image,name,description,user}) => {
    return (
        <div className='relative flex w-full h-full px-4 xs:px-[8%] sm:px-[13%] md:px-[5%] xl:px-[13%] font-nunito'>
            <FileImage file={image} className='absolute left-0 top-0 w-full h-full object-cover bg-center'/>
            <div className='absolute flex  left-0 top-0 w-full h-full shrink-0 bg-linear-to-b from-[rgba(0,0,0,.5)] via-transparent to-[rgba(0,0,0,.5)]'/>
            <div className='relative flex flex-row w-full h-full'>
                <div className='flex flex-col w-full md:w-[60%] h-full justify-center items-center md:items-start space-y-16'>
                    <div className='flex flex-col w-full h-fit space-y-4'>
                        <span className='text-sm text-white font-nunitoSansBold tracking-[2px] text-center md:text-left uppercase'>{name}</span>
                        <p className='text-[40px]/[1.2em] lg:text-[60px]/[1.2em] text-white font-nunitoSansBlack text-center md:text-left'>{description}</p>
                    </div>
                    {!user && 
                    <Button onClick = {(e) => {
                        e.preventDefault();
                        window.location.href = "https://portal.coaz.org/_register"
                    }} 
                    text='Join us'/>}
                </div>
            </div>
        </div>
    )
}

const Bullet = ({index,current}) => {
    useEffect(() => {
        
    })
    return (
        <div style={{transition:'all 1s ease-in-out'}} 
            className={`flex w-2 h-2 z-20 rounded-full ${current && current.index === index?'bg-[rgb(0,175,240)]':'bg-[rgb(223,223,223)]'} cursor-pointer`}
        />
    )
}

const FileImage = ({ file, ...props }) => {
    const [url, setUrl] = useState(null);

    useEffect(() => {
        if (!file) {
            return;
        }
        const objectUrl = URL.createObjectURL(file);
        setUrl(objectUrl);

        return () => {
            URL.revokeObjectURL(objectUrl);
        };
    }, [file]);

    if (!url) return null;

    return <img 
        src={url}
        {...props} />
};

const EditSlides = ({params}) => {
    const [selectedSlide, setSelectedSlide] = useState(null);
    const [slides,setSlides] = useState([]);

    const handleFileChosen = (file) => {
        if (!file) return;

        const extension = file.name.split(".").pop().toLowerCase();

        // Optional validation
        const allowedExtensions = ["jpg", "jpeg", "png", "gif", "webp"];

        if (!allowedExtensions.includes(extension)) {
            alert("Please select a valid image.");
            return;
        }

        if(selectedSlide) {
            setSelectedSlide({
                ...selectedSlide,
                file:file
            })
        } else {
            setSelectedSlide({
                file:file
            })
        }
    };

    const updateSlide = (updated) => {
        setSlides(prev =>
            prev.map(slide => {
                const isSame =
                    (slide.ref?.id && updated.ref?.id &&
                        slide.ref.id === updated.ref.id)
                    ||
                    slide.tempId === updated.tempId;

                return isSame
                    ? { ...slide, ...updated }
                    : slide;
            })
        );
    };

    const clear = () => {
        setSelectedSlide(null);
    }

    useEffect(() => {
        setSlides(params && params.currentSlides?params.currentSlides.map(slide => ({...slide,tempId: crypto.randomUUID()})):[]);
    },[params.currentSlides])

    useEffect(() => {
        if(params.editSlidesDataRef) {
            params.editSlidesDataRef.current = slides;
        }
    },[slides])

    const slideStyle = "max-w-full min-h-[320px] max-h-[400px] object-cover";

    return (
        <div className='flex flex-col lg:flex-row gap-4 w-full lg:w-[900px] h-[640px] overflow-auto lg:overflow-hidden'>
            <div className='flex flex-col space-y-4 w-full h-auto lg:h-full lg:overflow-auto'>
                {slides && slides.length > 0 && 
                    slides.map((slide,i) => 
                    <div key={slide.tempId} className='relative flex flex-col w-full rounded-lg overflow-hidden shrink-0'>
                        {slide.file?
                        <FileImage
                            file={slide.file}
                            alt="Preview"
                            className={slideStyle}
                        />
                        :
                        <div className={"flex justify-center items-center bg-[rgb(247,247,247)] border border-[rgb(200,200,200)] border-dashed rounded-lg " + slideStyle}>
                            <PiImageThin size={64} className="text-theme" />
                        </div>
                        }
                        <div className='absolute flex flex-col w-[75%] lg:w-[60%] h-full space-y-2 justify-center p-4'>
                            <p className='font-nunitoSansBold text-[9px]/[12px] text-white uppercase'>{slide.name}</p>
                            <p className='font-nunitoSansBlack text-lg text-white'>{slide.description}</p>
                        </div>
                        <div className='absolute flex flex-row right-0 bottom-0 p-2 space-x-2'>
                            <button onClick={(e) => {
                                e.preventDefault();
                                setSelectedSlide(slide);
                            }} className='flex justify-center items-center w-6 h-6 bg-white text-gray hover:text-theme rounded-full shadow-md'>
                                <PiPencilSimple size={16}/>
                            </button>
                            <button onClick={(e) => {
                                e.preventDefault();
                                    setSlides(prev => prev.filter(s => s.tempId !== slide.tempId)
                                );
                            }} className='flex justify-center items-center w-6 h-6 bg-white text-gray hover:text-theme rounded-full shadow-md'>
                                <PiTrashLight size={16}/>
                            </button>
                        </div>
                    </div>)
                }
            </div>
            <div className="relative flex flex-col space-y-4 w-full lg:w-1/2 h-full shrink-0 overflow-hidden">
                <div
                    id="drop_zone"
                    onDrop={(e) => {
                        e.preventDefault();
                        handleFileChosen(e.dataTransfer.files[0]);
                    }}
                    onDragOver={(e) => {
                        e.preventDefault();
                    }}
                    className="flex flex-col w-full h-full items-center justify-center text-[rgb(93,93,93)] bg-[rgb(247,247,247)] border border-[rgb(200,200,200)] border-dashed rounded-lg p-4"
                >
                    {selectedSlide && (selectedSlide.file || selectedSlide.image)? (
                        <>
                            {selectedSlide.file &&
                            <FileImage file={selectedSlide.file}
                                alt="Preview"
                                className="max-h-[400px] max-w-full object-contain rounded-lg mb-4"
                            />
                            }

                            <p className="mb-2">{selectedSlide.file?selectedSlide.file.name:selectedSlide.image}</p>

                            <label
                                htmlFor="img"
                                className="cursor-pointer text-theme hover:underline"
                            >
                                Choose another image
                            </label>
                        </>
                    ) : (
                        <>
                            <PiImageThin size={64} className="text-theme" />

                            <p className="text-xl">
                                Drag and drop an image here
                            </p>

                            <p className="text-lg">-or-</p>

                            <label
                                htmlFor="img"
                                className="flex shrink-0 w-auto h-10 items-center justify-center text-xl hover:text-theme cursor-pointer"
                            >
                                Browse
                            </label>
                        </>
                    )}

                    <input
                        type="file"
                        id="img"
                        name="userImage"
                        accept="image/*"
                        className="hidden"
                        onChange={(e) => {
                            handleFileChosen(e.target.files?.[0]);
                        }}
                    />
                </div>
                <input
                    type="text"
                    value={selectedSlide && selectedSlide.name?selectedSlide.name:''}
                    placeholder='Name'
                    onChange={e => setSelectedSlide({...selectedSlide,name:e.target.value})}
                    className='flex w-full h-10 shrink-0 p-2 focus:outline-none text-sm font-light whitespace-nowrap bg-[rgb(247,247,247)] border border-[rgb(200,200,200)] border-dashed rounded-lg'
                />
                <textarea
                    value={selectedSlide && selectedSlide.description?selectedSlide.description:''}
                    placeholder="Description"
                    onChange={e => setSelectedSlide({...selectedSlide,description:e.target.value})}
                    className='flex w-full shrink-0 p-2 focus:outline-none text-sm font-light bg-[rgb(247,247,247)] border border-[rgb(200,200,200)] border-dashed rounded-lg'
                />
                {selectedSlide && 
                    <div className='absolute flex flex-row top-0 right-0 !m-0 p-2 space-x-2'>
                        {selectedSlide.file && selectedSlide.name && selectedSlide.description &&
                            <button onClick={(e) => {
                                e.preventDefault();
                                if (!selectedSlide) return;

                                const isExisting = selectedSlide.ref?.id || selectedSlide.tempId;

                                if (isExisting && slides.some(s =>
                                    s.tempId === selectedSlide.tempId || s.ref?.id === selectedSlide.ref?.id
                                )) {
                                    updateSlide(selectedSlide);
                                } else {
                                    const newSlide = {
                                        ...selectedSlide,
                                        tempId: crypto.randomUUID()
                                    };

                                    setSlides(prev => [...prev, newSlide]);
                                }

                                clear();
                            }} className='flex justify-center items-center w-6 h-6 bg-white text-gray hover:text-theme rounded-full shadow-md'>
                                <PiFloppyDiskLight size={16}/>
                            </button>
                        }
                        <button onClick={(e) => {
                            e.preventDefault();
                            clear();
                        }} className='flex justify-center items-center w-6 h-6 bg-white text-gray hover:text-theme rounded-full shadow-md'>
                            <PiEraserLight size={16}/>
                        </button>
                    </div>
                }
            </div>
        </div>
    );
};